import type { ModelInstanceFormValues } from '@/delivery-type-plugin/capabilities/maas-model-storage/modelInstanceTypes';

/** 是否勾选「缓存节点配置」（仅 true 时组装/校验 spec.kvOffload） */
export function isMiKvOffloadModuleEnabled(values: Pick<ModelInstanceFormValues, 'skuResourceModules'> | undefined): boolean {
  return values?.skuResourceModules?.kvOffload === true;
}
